import { useAppDispatch } from '@/hooks/useAppDispatch';
import { removeUser } from '@/slice/user';
import { ROUTES } from '@/types/routes';
import { useMutation } from '@tanstack/react-query';
import { Form, Input, Button, Typography, message } from 'antd';
import { useNavigate } from 'react-router';
import { updatePassword } from 'src/api/consultants';
import { SvgIcon } from 'src/components/icon';
import { logout } from '@/api/auth';

export default function ChangePassword(): JSX.Element {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  console.log(
    'isDisabled',
    form.getFieldsError().some(({ errors }) => errors.length > 0),
    form.getFieldsValue(),
    form.getFieldValue('newPassword'),
    form.getFieldValue('confirmPassword'),
  );
  const { mutateAsync: updateProfile, isPending } = useMutation({
    mutationFn: () => {
      const { currentPassword, newPassword, confirmPassword } =
        form.getFieldsValue();

      return updatePassword(currentPassword, newPassword, confirmPassword);
    },
    onSuccess: () => {
      message.success('Profile updated successfully!');
    },
    onError: (error: any) => {
      console.log(error);
      message.error(
        error.message || 'Profile update failed. Please try again.',
      );
    },
  });
  const generateErrorMessage = (errorText: string) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <SvgIcon type={'alert'} />
        <Typography.Text style={{ color: '#F46262' }}>
          {errorText}
        </Typography.Text>
      </div>
    );
  };
  const onFinish = async () => {
    await updateProfile();
    await logout();
    localStorage.clear();
    dispatch(removeUser());
    navigate(ROUTES.ADMIN_DASHBOARD_SIGN_IN);
  };
  return (
    <div>
      <Form
        form={form}
        layout={'vertical'}
        name={'basic'}
        onFinish={onFinish}
        className={'admin-forgot-form'}
      >
        <Form.Item
          name={'currentPassword'}
          label={<label style={{ color: '#9FA1AD' }}>Current Password</label>}
          rules={[
            {
              required: true,
              message: generateErrorMessage('Please input your password!'),
            },
          ]}
        >
          <Input.Password
            placeholder={'Enter here'}
            className={'admin-input-password'}
          />
        </Form.Item>
        <Form.Item
          name={'newPassword'}
          dependencies={['confirmPassword']}
          label={<label style={{ color: '#9FA1AD' }}>New Password</label>}
          rules={[
            {
              required: true,
              message: generateErrorMessage('Please input your new password!'),
            },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
              message: generateErrorMessage(
                'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.',
              ),
            },
          ]}
        >
          <Input.Password
            placeholder={'Enter here'}
            className={'admin-input-password'}
          />
        </Form.Item>
        <Form.Item
          name={'confirmPassword'}
          label={<label style={{ color: '#9FA1AD' }}>Repeat Password</label>}
          dependencies={['newPassword']}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(
                    generateErrorMessage('Please confirm your password.'),
                  );
                }
                if (getFieldValue('newPassword') !== value) {
                  return Promise.reject(
                    generateErrorMessage('Passwords do not match.'),
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password
            placeholder={'Enter here'}
            className={'admin-input-password'}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type={'primary'}
            htmlType={'submit'}
            className={'admin-forgot-button'}
            loading={isPending}
          >
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
